require('src/creative/core-page/editorial-review-drawer/editorial-review-drawer.scss');
require('src/interlock/ui/expandable/expandable.js');


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/editorial-review-drawer/editorial-review-drawer.js
// module id = 173
// module chunks = 1 6 28